export type ReportSort = { column: string; direction: 'asc' | 'desc' }

export type SortValue = string | number | null

// A missing value sorts last in either direction, and the original order
// breaks a tie, so the same click always gives the same order.
export function sortRows<Row>(rows: Row[], value: (row: Row) => SortValue, direction: 'asc' | 'desc'): Row[] {
  const sign = direction === 'asc' ? 1 : -1
  return rows
    .map((row, index) => ({ row, index, key: value(row) }))
    .sort((a, b) => {
      if (a.key === null && b.key === null) return a.index - b.index
      if (a.key === null) return 1
      if (b.key === null) return -1
      const order = typeof a.key === 'string' && typeof b.key === 'string' ? a.key.localeCompare(b.key) : Number(a.key) - Number(b.key)
      return order * sign || a.index - b.index
    })
    .map((entry) => entry.row)
}

export function nextSort(current: ReportSort, column: string): ReportSort {
  return current.column === column ? { column, direction: current.direction === 'asc' ? 'desc' : 'asc' } : { column, direction: 'asc' }
}
